import BreadCrumpView from '../view/table_view';
import {connect} from "react-redux";
import { RootState } from "../../../app/store"
import { Dispatch } from '@reduxjs/toolkit';
import { requestDataFromAPI} from '../thunk/table_tunc';

interface OwnProps {
    id:string
}

function mapStateToProps(state:RootState, ownProps:OwnProps){  
    const myprops=
    {
        entry:state.breadCrump.model.entry,
        link:state.breadCrump.model.link,
        visible: false,
        condition: true,
        itemToDelete: "null",
        view:state.breadCrump.view,
    }
    return myprops;
}

function bindDispatchToActions(dispatch:Dispatch<any>, ownProps:OwnProps){
    return {
        onLoadRequested:()=>{ 
            dispatch(requestDataFromAPI() as any);
        },
    }
}


const BreadCrumpContainer=connect(mapStateToProps, bindDispatchToActions)(BreadCrumpView);
export default BreadCrumpContainer;